import Divider from '@mui/material/Divider';
import Hero from './components/Hero';
import ColorsCheckbox from './components/RibbonColorCheckBoxes';
import BoxForOptions from './components/BoxForOptions';
import SubmittSelections from './components/SumbitSelections';
import ImageGallery from './components/ImageGallery';
import TokenValidate from './components/TokenValidation';
import { Box, Container, Typography } from '@mui/material';
import {useMediaQuery} from '@mui/material';
import DynamicInfoAlert from './components/DynamicInfoAlert';



export default function LandingPage() {

  const ismobile = useMediaQuery('(max-width:600px)');
  const containerSize = ismobile ? true : false
  
  return (
    <Container
      maxWidth="lg"
      disableGutters={containerSize}
     
    >
      
      <Hero />  
      <DynamicInfoAlert/>
      <Box sx={{
            display: {md: "none",xs: ""},
            p: 2,
          }}>
            <Divider sx={{ '--Divider-childPosition': '50%',  fontWeight: 200, fontSize: 16, }}>
              
              Customize and Order Your Ribbon
            
            </Divider>
          </Box>
      <Box
        sx={{ 
          position: "relative",
          display: "flex",
          width: "100%",
          flexWrap: {md: 'nowrap',xs: 'wrap'},
          justifyContent: "center",
          paddingTop: {md: 5, xs: 0},
          paddingLeft: 2,
          paddingRight: 2,
          border: {md: "1px solid", xs: ""},
          borderColor: {md: "divider", xs: ""},
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",

        }}
        >
          
          
      
          <Typography variant='h6' align='center'  sx={{
            display: {md: "flex", xs: "none"},
            position: "absolute",
            top: -16,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            padding: "0 10px",
            fontWeight: 200,
            fontSize: 18,
            }}>
              Customize and Order Your Ribbon
          </Typography>

          
          
         

           
          <Box sx={{
            display: "flex",
            width: "100%"
            // flex: {md: 1, xs: ""},
            }}>
               
            <BoxForOptions/>
          </Box>

      </Box>
      <SubmittSelections/>
      <ImageGallery/>
      <TokenValidate/>
      </Container>

      
     
  
    
  );
}

